import { render, staticRenderFns } from "./NovedadesView.vue?vue&type=template&id=75d3cda2&"
import script from "./NovedadesView.vue?vue&type=script&lang=js&"
export * from "./NovedadesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports